import { useEffect } from "react";
import { NaeSSchemaMap } from '../../_custom/config/NaeSSchema';
import { useDataCache } from "@newageerp/v3.app.data-cache-provider";
import { useSelector } from "@newageerp/v3.templates.templates-core";
import { SelectorPaymentNae } from "../models/ormSelectors";

interface ChildId {
  id: number
}

export interface IPaymentModelNae {
    _viewTitle: string,
      id: number,
      scopes: any,
      badges: any,
  }

export const IPaymentFieldsNae = [
    "_viewTitle",
    "id",
    "scopes",
    "badges"
];

export function usePaymentHookNae(id: number) : IPaymentModelNae {
  // @ts-ignore
  const element = useSelector((state) => SelectorPaymentNae(state, id));

  const { addToQueue } = useDataCache();

  useEffect(() => {
    if (!element) {
      addToQueue({
        elementId: id,
        schema: NaeSSchemaMap.Payment.schema,
        fields: IPaymentFieldsNae,
      });
    }
  }, [element, id]);

  return element;
}
